// extracted by mini-css-extract-plugin
module.exports = {"desc":"desc___1GTAb","tagMarkdown":"tagMarkdown___1C8Mn","markdownTable":"markdownTable___2h0g1"};